import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    AddCererePayload,
    EditCererePayload,
    EditRequestStatusPayload,
    EditRequestPriorityPayload,
    EditRequestAssigneePayload,
    extraActionCererePayload,
    DocumentData,
    UpdateMassAssignPayload,
    UpdateMassStatusPayload,
    IInchidereLucrare,
    UpdateMassPriorityPayload,
    UsersByCompartimentePayload,
    DocumentUat,
    ResetEmailPayload,
    EditDialogPayload,
} from './cereri.interface';
import { Observable, Subject, catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CereriService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getRequestsURL =
        this.basePath + environment.interop.dgitl.cerere;
    private getRequestsDTURL =
        this.basePath + environment.interop.dgitl.cerere.getCereriDT;
    private findCerere =
        this.basePath + environment.interop.dgitl.cerere.findCerere;
    private getInfoDocListURL =
        this.basePath + environment.interop.dgitl.cerere;
    private storeRequestsURL =
        this.basePath + environment.interop.dgitl.cerere.storeCereri;
    private updateRequestURL =
        this.basePath + environment.interop.dgitl.cerere;
    private deleteRequestURL =
        this.basePath + environment.interop.dgitl.cerere;
    private updateStatusURL =
        this.basePath + environment.interop.dgitl.cerere.updateStatus;
    private updatePriorityURL =
        this.basePath + environment.interop.dgitl.cerere.updatePriority;
    private updateAssigneeURL =
        this.basePath + environment.interop.dgitl.cerere.updateAssignee;

    private getCompartimenteURL =
        this.basePath + environment.interop.dgitl.cerere.getCompartimente;
    private getCompartimenteByAccessURL =
        this.basePath + environment.interop.dgitl.cerere.getCompartimenteByAccess;
    private getActiveUsersByCompartimentURL =
        this.basePath + environment.interop.dgitl.cerere.getActiveUsersByCompartiment;

    private postMessageURL =
        this.basePath + environment.interop.dgitl.cerere.postMessage;
    private rePostMessageURL =
        this.basePath + environment.interop.dgitl.cerere.rePostMessage;
    private getMessagesURL =
        this.basePath + environment.interop.dgitl.cerere.getMessages;

    // new routes
    private preluarePersonalaUrl =
        this.basePath + environment.interop.dgitl.cerere.preluarePersoanala;
    private preluareNumarRegistraturaUrl =
        this.basePath +
        environment.interop.dgitl.cerere.preluareNumarRegistratura;
    private validateCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.validateCerere;
    private invalidateCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.invalidateCerere;
    private anulareCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.anulareCerere;
    private finalizareCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.finalizareCerere;
    private getCerereTypesUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereType.getCerereTypes;

    // operations
    public downloadDocumentUrl =
        this.basePath + environment.interop.dgitl.cerere.downloadDocument;

    private fileUploadUrl =
        this.basePath + environment.interop.dgitl.cerere.file.fileUpload;
    private fileUploadBase64Url =
        this.basePath + environment.interop.dgitl.cerere.file.fileUploadBase64;

    private getSourcesURL =
        this.basePath + environment.interop.dgitl.cerere.getSources;
    // Directii

    private getDirectiiActiveUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.directie.getDirectiiActive;

    private getTipuriByDepartamenteUrl =
        this.basePath +
        environment.interop.dgitl.cerere.getTipuriByDepartament;

    // Mass update & assign

    private massUpdateStatusURL =
        this.basePath + environment.interop.dgitl.cerere.massUpdateStatus;

    private massAssignURL =
        this.basePath + environment.interop.dgitl.cerere.massAssign;

    private massUpdatePriorityURL =
        this.basePath + environment.interop.dgitl.cerere.massUpdatePriority;

    private massInchidereLucrareURL =
        this.basePath + environment.interop.dgitl.cerere.massInchidereLucrare;

    public downloadTableSignaturesURL =
        this.basePath + environment.interop.dgitl.cerere;

    private sablonContent = new Subject<string>();
    sablonContent$ = this.sablonContent.asObservable();

    private sendDocumentToIntocmitorUrl =
        this.basePath +
        environment.interop.dgitl.cerere;
    private sendDocumentForwardIntocmitorUrl =
        this.basePath +
        environment.interop.dgitl.cerere;
    private sendDocumentForwardToSignerUrl =
        this.basePath +
        environment.interop.dgitl.cerere;

    private rsyncSignaturesDocumentGeneratUrl =
        this.basePath +
        environment.interop.dgitl.cerere;

    private exportHistoryUrl =
        this.basePath + environment.interop.dgitl.cerere.exportHistory;

    private exportDocumentUatUrl =
        this.basePath + environment.interop.dgitl.cerere.exportDocumentUat;


    private resetValidareCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.resetValidareCerere;

    private resetinValidareCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.resetinValidareCerere;


    private resetClasareCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.resetClasareCerere;


    private resetInchidereCerereUrl =
        this.basePath + environment.interop.dgitl.cerere.resetInchidereCerere;

    private sendNotificationCetateanDocumentOficialUrl =
        this.basePath + environment.interop.dgitl.cerere;

    private sendEmailUrl =
        this.basePath + environment.interop.dgitl.cerere.sendEmail;

    private resetEmailUrl =
        this.basePath + environment.interop.dgitl.cerere.resetEmail;

    private getMatricoleUrl =
        this.basePath + environment.interop.dgitl.cerere.getMatricole;

    public downloadCFUrl =
        this.basePath + environment.interop.dgitl.cerere.downloadCF;

    private cancelCFUrl =
        this.basePath + environment.interop.dgitl.cerere.cancelCF;

    private generateCFUrl =
        this.basePath + environment.interop.dgitl.cerere.generateCF;

    private updateEmailUrl = this.basePath + environment.interop.dgitl.cerere.updateEmailCetatean;

    constructor(private http: HttpClient) { }

    getRequestTypes() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereTypesUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request types:', error);
                    return throwError(error);
                })
            );
    }

    getRequests() {
        return this.http.get(this.getRequestsURL, this.httpOptions);
    }

    getRequestsDT() {
        return this.http.get(this.getRequestsDTURL, this.httpOptions);
    }

    getRequestById(id: number) {
        return this.http.get(this.findCerere + id);
    }

    addRequest(formData: FormData) {
        return this.http.post<{ data: any }>(this.storeRequestsURL, formData);
    }

    updateRequest(request: EditCererePayload) {
        return this.http.put(this.updateRequestURL, request, this.httpOptions);
    }

    deleteRequest(id: number) {
        return this.http.delete(this.deleteRequestURL + id);
    }

    getInfoDocList(id: number) {
        return this.http.get(this.getInfoDocListURL + id);
    }

    updateRequestStatus(requestId: number, status: EditRequestStatusPayload) {
        return this.http.post(
            this.updateStatusURL + requestId,
            status,
            this.httpOptions
        );
    }

    updateRequestPriority(
        requestId: number,
        priority: EditRequestPriorityPayload
    ) {
        return this.http.post(
            this.updatePriorityURL + requestId,
            priority,
            this.httpOptions
        );
    }

    updateRequestAssignee(requestId: number, data: EditRequestAssigneePayload) {
        return this.http.post(
            this.updateAssigneeURL + requestId,
            data,
            this.httpOptions
        );
    }

    postMessage(id: number, message: any) {
        return this.http.post(this.postMessageURL + id, message, this.httpOptions);
    }

    rePostMessage(id: number) {
        return this.http.post(this.rePostMessageURL + id, this.httpOptions);
    }

    preluarePersonala(cerereId: number) {
        return this.http.get(
            this.preluarePersonalaUrl + cerereId,
            this.httpOptions
        );
    }

    validateCerere(cerereId: number) {
        return this.http.post(this.validateCerereUrl + cerereId, this.httpOptions);
    }

    invalidateCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.invalidateCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    anulareCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.anulareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    finalizareCerere(cerereId: number, data: IInchidereLucrare) {
        return this.http.post(
            this.finalizareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    downloadTableSignatures(id: number) {
        return this.http.get(this.downloadTableSignaturesURL + id);
    }

    getDirectii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getRequestsIDs() {
        return this.http.get<any>(this.getRequestsDTURL).pipe(
            map((response) =>
                response.data.data.map((item: any) => ({
                    id: item.id_cerere,
                    name: item.subject,
                }))
            ),
            catchError((error) => {
                console.error('Error in get requests select:', error);
                return throwError(error);
            })
        );
    }

    updateMassAssign(data: UpdateMassAssignPayload) {
        return this.http.post(this.massAssignURL, data, this.httpOptions);
    }

    updateMassStatus(data: UpdateMassStatusPayload) {
        return this.http.post(this.massUpdateStatusURL, data, this.httpOptions);
    }

    updateMassPriority(data: UpdateMassPriorityPayload) {
        return this.http.post(this.massUpdatePriorityURL, data, this.httpOptions);
    }

    updateMassInchidereLucrare(data: any) {
        return this.http.post(this.massInchidereLucrareURL, data, this.httpOptions);
    }

    preluareNumarRegistratura(cerereId: number) {
        return this.http.put(
            this.preluareNumarRegistraturaUrl + cerereId,
            this.httpOptions
        );
    }

    sendContent(content: string) {
        this.sablonContent.next(content);
    }

    sendDocumentToIntocmitor(signatureId: number, data: any) {
        return this.http.put(this.sendDocumentToIntocmitorUrl + signatureId, data);
    }

    sendDocumentForwardIntocmitor(documentId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardIntocmitorUrl + documentId,
            data
        );
    }

    sendDocumentForwardToSigner(signatureId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardToSignerUrl + signatureId,
            data
        );
    }

    rsyncSignaturesDocumentGenerat(documentId: number, data: any = {}) {
        return this.http.post(
            this.rsyncSignaturesDocumentGeneratUrl + documentId,
            data
        );
    }

    exportHistory(cerere_id: number, user_type: number): Observable<Blob> {
        return this.http.get(this.exportHistoryUrl + cerere_id + '/' + user_type, {
            responseType: 'blob',
        });
    }

    exportDocumentUat(data: DocumentUat) {
        return this.http.post(this.exportDocumentUatUrl, data, { responseType: 'blob' });
    }

    resetValidareCerere(cerereId: number, data: any) {
        return this.http.put(
            this.resetValidareCerereUrl + cerereId,
            data
        );
    }

    resetinValidareCerere(cerereId: number, data: any) {
        return this.http.put(
            this.resetinValidareCerereUrl + cerereId,
            data
        );
    }

    resetClasareCerere(cerereId: number, data: any) {
        return this.http.put(
            this.resetClasareCerereUrl + cerereId,
            data
        );
    }

    resetInchidereCerere(cerereId: number, data: any) {
        return this.http.post(
            this.resetInchidereCerereUrl + cerereId,
            data
        );
    }

    sendNotificationCetateanDocumentOficial(documentGeneratId: number) {
        return this.http.get(this.sendNotificationCetateanDocumentOficialUrl + documentGeneratId, this.httpOptions);
    }

    getTipuriByDepartamenteId(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTipuriByDepartamenteUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_cerere_type,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getTipuriByDepartamenteId:', error);
                    return throwError(error);
                })
            );
    }

    getMessages(id: number) {
        return this.http.get(this.getMessagesURL + id);
    }

    getCompartimente() {
        return this.http.get(this.getCompartimenteURL, this.httpOptions);
    }

    getCompartimenteByAccess() {
        return this.http.get(this.getCompartimenteByAccessURL, this.httpOptions);
    }

    getActiveUsersByCompartiment(data: UsersByCompartimentePayload) {
        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(this.getActiveUsersByCompartimentURL, data, this.httpOptions)
            .pipe(
                map((response: any) =>
                    response.data.map((item: any) => ({ id: item.id, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error: ', error);
                    return throwError(error);
                })
            );
    }

    getSources() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getSourcesURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name.toUpperCase(),
                    })).sort((a, b) => a.id - b.id)
                ),
                catchError((error) => {
                    console.error('Error in get getSources: ', error);
                    return throwError(error);
                })
            );
    }

    sendEmail(formData: FormData) {
        return this.http.post<{ data: any }>(this.sendEmailUrl, formData);
    }

    resetEmail(data: ResetEmailPayload) {
        return this.http.put(this.resetEmailUrl, data, this.httpOptions)
    }

    getMatricole(id: number) {
        return this.http.get(this.getMatricoleUrl + id);
    }

    cancelCF(id: number, data: any) {
        return this.http.post(this.cancelCFUrl + id, data, this.httpOptions);
    }

    generateCF(id: number, data: any) {
        return this.http.post(this.generateCFUrl + id, data, this.httpOptions)
    }

    updateEmail(id: number, data: EditDialogPayload) {
        return this.http.post(this.updateEmailUrl + id, data);
    }
}
